var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 33") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2687,27.2674 L22.5227,27.2674 L22.5227,19.8414 C22.5227,18.0704 22.4927,15.7924 20.0567,15.7924 C17.5877,15.7924 17.2107,17.7224 17.2107,19.7144 L17.2107,27.2674 L12.4697,27.2674 L12.4697,11.9964 L17.0197,11.9964 L17.0197,14.0844 L17.0847,14.0844 C17.7177,12.8834 19.2657,11.6174 21.5747,11.6174 C26.3807,11.6174 27.2687,14.7794 27.2687,18.8924 L27.2687,27.2674 Z M7.1187,9.9104 C5.5937,9.9104 4.3647,8.6774 4.3647,7.1574 C4.3647,5.6384 5.5937,4.4054 7.1187,4.4054 C8.6367,4.4054 9.8697,5.6384 9.8697,7.1574 C9.8697,8.6774 8.6367,9.9104 7.1187,9.9104 L7.1187,9.9104 Z M9.4927,27.2674 L4.7417,27.2674 L4.7417,11.9964 L9.4927,11.9964 L9.4927,27.2674 Z M30.6667,0.0004 L1.3337,0.0004 C0.5967,0.0004 -0.0003,0.5974 -0.0003,1.3334 L-0.0003,30.6664 C-0.0003,31.4034 0.5967,32.0004 1.3337,32.0004 L30.6667,32.0004 C31.4027,32.0004 31.9997,31.4034 31.9997,30.6664 L31.9997,1.3334 C31.9997,0.5974 31.4027,0.0004 30.6667,0.0004 L30.6667,0.0004 Z",
    id: "Fill-33",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.68f5bd84d425070dac56ff8883103836.svg";
export { ForwardRef as ReactComponent };